import ButtonOnly from "../button/buttonOnly";
import "./footer.css";
function FooterButton({
  ftIdName,
  buttonClass = "inputBtn03",
  buttonValue = "훈련 시작하기",
  onFinish,
}) {
  return (
    <div id={ftIdName}>
      <ButtonOnly
        btnValue={buttonValue}
        btnClass={buttonClass}
        onFinish={onFinish}
      />
    </div>
  );
}

export default FooterButton;
